var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ui-text-clickable",class:{ shade: _vm.shade, disabled: _vm.disabled, 'pa-4': _vm.pa, 'px-4': _vm.px },on:{"click":_vm.click}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }